export const normativeHelpIds: { [id: string]: string } = {
    1: "/document?moduleId=1&documentId=257625&cwi=379#h427",
    2: "/document?moduleId=1&documentId=257625&cwi=379#h428",
    3: "/document?moduleId=1&documentId=257625&cwi=379#h430",
    4: "/document?moduleId=1&documentId=257625&cwi=379#h431",
    5: "/document?moduleId=1&documentId=257625&cwi=379#h432",
    6: "/document?moduleId=1&documentId=257625&cwi=379#h433",
    7: "/document?moduleId=1&documentId=257625&cwi=379#h434",
    8: "/document?moduleId=1&documentId=257625&cwi=379#h435",
    9: "/document?moduleId=1&documentId=257625&cwi=379#h436",
    10: "/document?moduleId=1&documentId=257625&cwi=379#h437",
    11: "/document?moduleId=1&documentId=257625&cwi=379#h438",
    12: "/document?moduleId=1&documentId=257625&cwi=379#h440",
    13: "/document?moduleId=1&documentId=257625&cwi=379#h441",
    14: "/document?moduleId=1&documentId=257625&cwi=379#h442",
    15: "/document?moduleId=1&documentId=257625&cwi=379#h443",
    16: "/document?moduleId=1&documentId=257625&cwi=379#h444",
    17: "форма 4-фсс порядок заполнения",
    18: "/document?moduleId=1&documentId=257625&cwi=379#h429",
    19: "/document?moduleId=1&documentId=227816&cwi=13850#h922",
    20: "/document?moduleId=1&documentId=227816&cwi=13850#h938",
    21: "/document?moduleId=1&documentId=227816&cwi=13850#h1018",
    22: "/document?moduleId=1&documentId=227816&cwi=13850#h1019",
    23: "/document?moduleId=1&documentId=227816&cwi=13850#h1020",
    24: "/document?moduleId=1&documentId=227816&cwi=13850#h1021",
    25: "/document?moduleId=1&documentId=227816&cwi=13850#h1022",
    26: "/document?moduleId=1&documentId=227816&cwi=13850#h1023",
    27: "/document?moduleId=1&documentId=227816&cwi=13850#h1024",
    28: "/document?moduleId=1&documentId=227816&cwi=13850#h1025",
    29: "/document?moduleId=1&documentId=227816&cwi=13850#h1026",
    30: "/document?moduleId=1&documentId=227816&cwi=13850#h1060",
    31: "/document?moduleId=1&documentId=227816&cwi=13850#h1027",
    32: "/document?moduleId=1&documentId=227816&cwi=13850#h1011",
    33: "/document?moduleId=1&documentId=227816&cwi=13850#h1013",
    34: "/document?moduleId=1&documentId=227816&cwi=13850#h1014",
    35: "/document?moduleId=1&documentId=227816&cwi=13850#h1015",
    36: "/document?moduleId=1&documentId=227816&cwi=13850#h1016",
    37: "/document?moduleId=1&documentId=227816&cwi=13850#h1017",
    38: "/document?moduleId=1&documentId=270037#h427",
    39: "/document?moduleId=1&documentId=270037#h428",
    40: "/document?moduleId=1&documentId=270037#h429",
    41: "/document?moduleId=1&documentId=270037#h430",
    42: "/document?moduleId=1&documentId=270037#h431",
    43: "/document?moduleId=1&documentId=270037#h432",
    44: "/document?moduleId=1&documentId=270037#h433",
    45: "/document?moduleId=1&documentId=270037#h434",
    46: "/document?moduleId=1&documentId=270037#h435",
    47: "/document?moduleId=1&documentId=270037#h436",
    48: "/document?moduleId=1&documentId=270037#h437",
    49: "/document?moduleId=1&documentId=270037#h438",
    50: "/document?moduleId=1&documentId=270037#h440",
    51: "/document?moduleId=1&documentId=270037#h441",
    52: "/document?moduleId=1&documentId=270037#h442",
    53: "/document?moduleId=1&documentId=270037#h443",
    54: "/document?moduleId=1&documentId=270037#h444",
};
